export default __webpack_public_path__ + "static/media/official-4.ad971dfd.png";